import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['app', 'isDark']),
    
    hasWhitelabel () {
      return !!this.app.id
    },
    
    appLogo () {
      if (this.hasWhitelabel) {
        // console.log(this.app.designInformation)
        return this.app.designInformation.logos[this.isDark ? 'white' : 'normal']
      }
      
      return this.$assets.logo[this.isDark ? 'white' : 'normal']
    },

    appFavicon () { 
      return this.$assets.favicon[this.isDark ? 'white' : 'normal']
    },

    appWhiteFavicon () {      
      return this.$assets.favicon.white
    },

    footerFormat () {
      if (this.hasWhitelabel) {
        return this.app.designInformation.footerFormat
      } else {
        return 'MADEWITH'
      }
    },

    appName () {
      if (this.hasWhitelabel) {
        return this.app.name
      }
      
      return this.$i18n.t('app.site.layrz')
    }
  }
}